<!-- <div class="card" aria-hidden="true">
  <img src="..." class="card-img-top" alt="...">
  <div class="card-body">
    <h5 class="card-title placeholder-glow">
      <span class="placeholder col-6"></span>
    </h5>
    <p class="card-text placeholder-glow">
      <span class="placeholder col-7"></span>
      <span class="placeholder col-4"></span>
      <span class="placeholder col-4"></span>
      <span class="placeholder col-6"></span>
      <span class="placeholder col-8"></span>
    </p>
    <a href="#" tabindex="-1" class="btn btn-primary disabled placeholder col-6"></a>
  </div>
</div> -->

<div class="row" *ngIf="loading">
  <div class="col-md-2">
    <img src="assets/images/bookcover/loading.jpg"
      class="img-fluid img-thumbnail img-thumbnail-walai custom-img-shadow max-height-180" />
  </div>
  <div class="col-md-9">
    <h5 class="card-title placeholder-glow">
      <span class="placeholder col-6"></span>
    </h5>
    <p class="card-text placeholder-glow">
      <span class="placeholder col-7"></span>
      <span class="placeholder col-4"></span>
    </p>
  </div>
</div>

<div class="card border rounded-3 shadow-sm overflow-hidden h-100 bg-white" *ngIf="!loading">
  <div class="row g-0">
    <!-- Cover Section -->
    <div class="col-md-3 col-xl-2 bg-light d-flex align-items-center justify-content-center p-3 border-end-md">
      <div class="DivBookCover DivBookCover-list h-100">
        <a [href]="'bibitem?bibid=' + bibid" class="text-decoration-none h-100 d-block">
          <app-book-cover-share [bookCoverURL]="bookcoverUrl" [id]="bibid" [cssStyle]="'w-100 h-100'"
            [title]="title"></app-book-cover-share>
        </a>
      </div>
    </div>

    <!-- Details Section -->
    <div class="col-md-9 col-xl-10">
      <div class="card-body p-3 p-lg-4 d-flex flex-column h-100">
        <!-- Title -->
        <h5 class="mb-3">
          <a class="text-decoration-none text-dark fw-bold a-walai-book" target="_blank"
            href="bibitem?bibid={{ bibid }}" style="font-size: 1.15rem; line-height: 1.4;">
            {{ removeSlash(title) }}
          </a>
        </h5>

        <!-- Meta Data -->
        <div class="flex-grow-1 small text-dark">
          <div class="row mb-1" *ngIf="author">
            <div class="col-3 col-lg-2 text-secondary fw-medium">{{ "Author" | translate }}</div>
            <div class="col-9 col-lg-10">{{ author }}</div>
          </div>
          <div class="row mb-1" *ngIf="published">
            <div class="col-3 col-lg-2 text-secondary fw-medium">{{ "Published" | translate }}</div>
            <div class="col-9 col-lg-10">{{ published }}</div>
          </div>
          <div class="row mb-1" *ngIf="callnumber">
            <div class="col-3 col-lg-2 text-secondary fw-medium">{{ "Callnumber" | translate }}
            </div>
            <div class="col-9 col-lg-10"><span class="badge bg-light text-dark border">{{
                callnumber
                }}</span></div>
          </div>
          <div class="row mb-1" *ngIf="source">
            <div class="col-3 col-lg-2 text-secondary fw-medium">{{ "Source" | translate }}</div>
            <div class="col-9 col-lg-10">{{ source }}</div>
          </div>
          <div class="row mb-1" *ngIf="LOCATION">
            <div class="col-3 col-lg-2 text-secondary fw-medium">{{ "Location" | translate }}</div>
            <div class="col-9 col-lg-10">{{ LOCATION }}</div>
          </div>
        </div>

        <!-- Actions Bar -->
        <div class="mt-3 pt-3 border-top d-flex flex-wrap align-items-center gap-3">
          <app-electronic-resource [bibid]="bibid"></app-electronic-resource>

          <!-- <div class="ms-auto">
            <button type="button"
              class="btn btn-sm btn-light btn-light-walai border rounded-pill text-dark px-3 shadow-none gap-2"
              (click)="save(bibid)" title="{{'Save for export'| translate}}">
              <i class="bi bi-bookmark-plus me-2"></i>
              <span>{{'Save' | translate}}</span>
            </button>
          </div> -->
        </div>

      </div>
    </div>
  </div>
</div>